import { ComponentProps, FC } from 'react';

const NordelSVG: FC<ComponentProps<'svg'>> = (props) => {
  return (
    <svg
      width="68"
      height="13"
      viewBox="0 0 68 13"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="scale(0.1188, 0.1188)">
        <g>
          <path
            d="M157.1,111.9c-8.1,0-15.6-1.4-22.4-4.3c-6.8-2.9-12.7-6.8-17.5-11.8c-4.9-5-8.7-10.9-11.4-17.8
                c-2.8-6.8-4.1-14.2-4.1-22.1c0-7.9,1.4-15.3,4.1-22.1c2.8-6.8,6.6-12.7,11.4-17.8c4.9-5,10.7-9,17.5-11.8
                c6.8-2.9,14.3-4.3,22.4-4.3s15.6,1.4,22.4,4.3C186.3,7.1,192.2,11,197,16c4.9,5,8.7,10.9,11.4,17.8c2.8,6.8,4.1,14.2,4.1,22.1
                c0,7.9-1.4,15.3-4.1,22.1c-2.8,6.8-6.6,12.7-11.4,17.8c-4.9,5-10.7,9-17.5,11.8C172.7,110.5,165.2,111.9,157.1,111.9z
                 M157.1,98.4c6.1,0,11.6-1.1,16.6-3.4c4.9-2.3,9.1-5.3,12.6-9.1s6.2-8.3,8.1-13.5s2.9-10.7,2.9-16.5s-1-11.3-2.9-16.5
                s-4.6-9.7-8.1-13.5s-7.7-6.8-12.6-9.1s-10.4-3.4-16.6-3.4c-6.1,0-11.6,1.1-16.6,3.4c-4.9,2.3-9.1,5.3-12.6,9.1s-6.2,8.3-8.1,13.5
                s-2.9,10.7-2.9,16.5s1,11.3,2.9,16.5s4.6,9.7,8.1,13.5s7.7,6.8,12.6,9.1C145.4,97.3,150.9,98.4,157.1,98.4z"
          />
          <path
            d="M226.3,2.7h37.5c6.8,0,12.4,0.9,16.9,2.8c4.4,1.9,7.9,4.2,10.5,7.1c2.6,2.9,4.3,6.1,5.3,9.6
                c1,3.6,1.5,7,1.5,10.3c0,3.4-0.6,6.7-1.8,9.9c-1.2,3.2-2.9,6-5.2,8.6c-2.3,2.6-5,4.7-8.3,6.5s-6.9,2.8-10.9,3.2l30.2,48.6h-18
                l-27.1-46.9h-16.1v46.9h-14.4V2.7H226.3z M240.8,49.6h19c2.8,0,5.6-0.2,8.4-0.7s5.2-1.3,7.4-2.5c2.2-1.2,3.9-2.9,5.2-5.2
                c1.3-2.3,2-5.2,2-8.8s-0.7-6.5-2-8.8s-3-4-5.2-5.2s-4.6-2-7.4-2.5s-5.5-0.7-8.4-0.7h-19V49.6z"
          />
          <path
            d="M315.9,2.7H353c7.5,0,14.1,0.9,19.8,2.6c5.7,1.7,10.6,4,14.7,6.8c4.2,2.9,7.6,6.1,10.4,9.9
                c2.8,3.7,4.9,7.5,6.5,11.4s2.8,7.8,3.5,11.7s1.1,7.5,1.1,10.8c0,6.8-1.3,13.4-3.8,19.8c-2.5,6.4-6.2,12-11.1,17
                c-4.9,5-11,9-18.3,12s-15.7,4.5-25.2,4.5h-34.8L315.9,2.7L315.9,2.7z M330.3,95.7h18.2c6.1,0,11.9-0.8,17.4-2.5
                s10.3-4.1,14.4-7.4c4.1-3.3,7.4-7.4,9.8-12.4c2.4-5,3.6-10.8,3.6-17.4c0-3.4-0.6-7.4-1.7-12c-1.1-4.6-3.2-8.9-6.2-13
                c-3.1-4.1-7.3-7.6-12.7-10.5c-5.4-2.9-12.4-4.3-21.1-4.3h-21.7L330.3,95.7L330.3,95.7z"
          />
          <path d="M423.7,2.7h68.8v13.5h-54.3v31.7h50.6v13.5h-50.6v34.2h57v13.5h-71.5V2.7z" />
          <path d="M510.7,2.7h14.4v93H574v13.5h-63.3V2.7z" />
          <g>
            <path
              d="M86.9,109.4H72.1V43.5c0-15.8-12.8-28.6-28.6-28.6S14.9,27.7,14.9,43.5v65.9H0V43.5C0,19.5,19.5,0,43.5,0
                    S87,19.5,87,43.5v65.9H86.9z"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1059_12492">
          <rect width="49" height="13" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NordelSVG;
